<template>
  <div id="app">
    <router-view></router-view>
    <headd></headd>
    <Footer></Footer> 
  </div>
</template>

 <script src="https://unpkg.com/vue-router/dist/vue-router.js"></script>


<script>
import Headd from "./components/Headd";
import Footer from "./components/Footer"

export default {
  name: "app",
  components: {
    Footer,
    Headd
  },
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color:#fff;
  max-width: 100vw;
}
p{
  color: #A19DAF
}
body {
  background: black;
}
</style>
